<section class="listings-section" dir="rtl">
  <div #scrollContainer class="scroll-container">
    <div class="listings-grid">

      @for (item of productsList; track item) {
        <article
          class="card"
          [class.card--featured]="item.adsRoute?.level === 'LEVEL2'"
          [class.card--super]="item.adsRoute?.level === 'LEVEL3'"
          [class.card--map-hover]="mapService.active && mapService.hoveredId === item.id"
          [attr.data-type]="item.resourcetype"
          (mouseenter)="onCardEnter(item)"
          (mouseleave)="onCardLeave()"
          >
          <!-- ══ SHARED: IMAGE ══════════════════════════════════════ -->
          <a [routerLink]="['/single/' + item.id]" (click)="saveState()" class="card__image-link">
            <div class="card__image-wrapper">
              <!-- Category chip -->
              <span class="card__category-chip">
                <span>{{ getCategoryIcon(item.resourcetype) }}</span>
                {{ getCategoryLabel(item) }}
              </span>
              <!-- Tier badges -->
              @if (item.adsRoute?.level === 'LEVEL3') {
                <span class="card__tier card__tier--super"   >★ Super Gold</span>
              }
              @if (item.adsRoute?.level === 'LEVEL2') {
                <span class="card__tier card__tier--featured">מודגש</span>
              }
              <!-- SCRUM-262 / 266: advertiser type + "ממומן" on the photo, bottom-left -->
              @if (businessTag(item) || isSponsored(item)) {
                <div class="card__img-badges">
                  @if (isSponsored(item)) {
                    <span class="card__img-badge card__img-badge--sponsored"><i class="mdi mdi-bullhorn"></i> ממומן</span>
                  }
                  @if (businessTag(item); as tag) {
                    <span class="card__img-badge card__img-badge--biz">
                      <i class="mdi {{ tagIcon(item) }}"></i> {{ tag }}
                      @if (businessStore(item)?.verified) {
                        <i class="mdi mdi-check-circle card__img-badge-verified" [title]="businessStore(item)?.verified_text"></i>
                      }
                    </span>
                  }
                </div>
              }
              <!-- Market product badge -->
              @if (item.is_market_product) {
                <span class="card__market-badge">
                  <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor" style="display:inline;vertical-align:middle;margin-left:3px"><path d="M3 1a1 1 0 0 0 0 2h1.22l.305 1.222a.997.997 0 0 0 .01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 0 0 0-2H6.414l1-1H14a1 1 0 0 0 .894-.553l3-6A1 1 0 0 0 17 3H6.28l-.31-1.243A1 1 0 0 0 5 1H3zm12 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/></svg>
                  זמין לרכישה
                </span>
              }
              <img
                class="card__image"
                [src]="item.images?.[0]?.image || ''"
                [alt]="item.name"
                loading="lazy"
                />
                <div class="card__hover-overlay">
                  <span class="card__hover-cta">צפייה בפרסום</span>
                </div>
              </div>
            </a>
            <!-- ══ SHARED: TITLE ══════════════════════════════════════ -->
            <a [routerLink]="['/single/' + item.id]" (click)="saveState()" class="card__title-link">
              <h3 class="card__title">{{ getTitle(item) }}</h3>
            </a>
            <!-- ══ TYPE-SPECIFIC BODY ════════════════════════════════ -->
            <div class="card__body">
              @switch (item.resourcetype) {
                <!-- ─── CAR ──────────────────────────────────────────── -->
                @case ('Car') {
                  <div class="card__meta-row">
                    @if (item.year) {
                      <span class="meta-tag meta-tag--year"   >{{ item.year }}</span>
                    }
                    @if (item.mileage != null) {
                      <span class="meta-tag meta-tag--neutral">{{ item.mileage | number }} ק״מ</span>
                    }
                    @if (item.NumberOfOwner?.numberOnwer) {
                      <span class="meta-tag meta-tag--neutral">{{ item.NumberOfOwner.numberOnwer }}</span>
                    }
                  </div>
                  @if (item.city?.nameHe) {
                    <div class="card__location">
                      <span class="location-pin">📍</span> {{ item.city.nameHe }}
                    </div>
                  }
                  @if (item.armatureList?.length) {
                    <div class="card__features">
                      @for (f of item.armatureList | slice:0:2; track f) {
                        <span class="feature-tag">{{ f.ArmatureDesc }}</span>
                      }
                      @if (item.armatureList.length > 2) {
                        <span class="feature-tag feature-tag--more">
                          +{{ item.armatureList.length - 2 }}
                        </span>
                      }
                    </div>
                  }
                  <div class="card__badges">
                    @if (item.exchange) {
                      <span class="badge badge--swap"    >⇄ חליפין</span>
                    }
                    @if (item.DisabledSuitable) {
                      <span class="badge badge--disabled">♿ מתאים לנכים</span>
                    }
                  </div>
                }
                <!-- ─── NADLAN ─────────────────────────────────────── -->
                @case ('Nadlan') {
                  <div class="card__meta-row">
                    <span class="meta-tag meta-tag--highlight">{{ item.sconderyCategory?.name }}</span>
                    @if (item.RoomsNum?.numberOfRooms) {
                      <span class="meta-tag meta-tag--neutral">
                        {{ item.RoomsNum.numberOfRooms }} חדרים
                      </span>
                    }
                    @if (item.Floor != null) {
                      <span class="meta-tag meta-tag--neutral">
                        קומה {{ item.Floor }}
                      </span>
                    }
                  </div>
                  @if (item.City?.nameHe || item.Street?.nameHe) {
                    <div class="card__location">
                      <span class="location-pin">📍</span>
                      {{ item.Street?.nameHe }}{{ item.Street?.nameHe && item.City?.nameHe ? ', ' : '' }}{{ item.City?.nameHe }}
                      @if (mapService.active && hasPosition(item)) {
                        <button type="button" class="card__map-btn" (click)="showOnMap($event, item)" aria-label="הצג במפה">הצג במפה</button>
                      }
                    </div>
                  }
                  <div class="card__meta-row card__meta-row--secondary">
                    @if (item.buildingMeterTotal) {
                      <span class="meta-tag meta-tag--neutral">{{ item.buildingMeterTotal }} מ"ר</span>
                    }
                    @if (item.ParkingNumber?.numberParking) {
                      <span class="meta-tag meta-tag--neutral">
                        {{ item.ParkingNumber.numberParking }} חניות
                      </span>
                    }
                    @if (item.StatusOfNadlan?.nameHe) {
                      <span class="meta-tag meta-tag--neutral">{{ item.StatusOfNadlan.nameHe }}</span>
                    }
                  </div>
                  @if (item.armatureList?.length) {
                    <div class="card__features">
                      @for (f of item.armatureList | slice:0:3; track f) {
                        <span class="feature-tag">{{ f.ArmatureDesc }}</span>
                      }
                    </div>
                  }
                }
                <!-- ─── SALE2 / CELLULAR / FURNITURE / FASHION ──────── -->
                @default {
                  @if (isSale2Type(item.resourcetype)) {
                    <div class="card__meta-row">
                      @if (item.ProductStatus?.statusName) {
                        <span class="meta-tag meta-tag--neutral"  >{{ item.ProductStatus.statusName }}</span>
                      }
                      @if (item.subCategory?.subCategoryName) {
                        <span class="meta-tag meta-tag--highlight">{{ item.subCategory.subCategoryName }}</span>
                      }
                    </div>
                    @if (item.producer || item.model) {
                      <div class="card__producer">
                        <strong>{{ item.producer }}</strong>
                        @if (item.model) {
                          <span> · {{ item.model }}</span>
                        }
                      </div>
                    }
                    <!-- Sale2 uses uppercase City -->
                    @if (item.City?.nameHe) {
                      <div class="card__location">
                        <span class="location-pin">📍</span> {{ item.City.nameHe }}
                      </div>
                    }
                    <div class="card__badges">
                      @if (item.DeliveryOffer) {
                        <span class="badge badge--delivery">🚚 משלוח</span>
                      }
                    </div>
                  }
                }
                <!-- ─── COWORKER ───────────────────────────────────── -->
                @case ('Coworker') {
                  @if (item.professionalTitle) {
                    <p class="card__subtitle">{{ item.professionalTitle }}</p>
                  }
                  <div class="card__meta-row">
                    <span class="meta-tag meta-tag--highlight">{{ item.professionCategory?.label }}</span>
                    <span class="meta-tag meta-tag--neutral">{{ item.serviceType?.label }}</span>
                  </div>
                  <!-- Coworker uses lowercase city -->
                  @if (item.city?.nameHe) {
                    <div class="card__location">
                      <span class="location-pin">📍</span> {{ item.city.nameHe }}
                    </div>
                  }
                  <div class="card__badges">
                    @if (item.availability?.label) {
                      <span class="badge badge--avail">⚡ {{ item.availability.label }}</span>
                    }
                    @if (item.experienceYears?.label) {
                      <span class="badge badge--exp"  >{{ item.experienceYears.label }}</span>
                    }
                    @if (item.pricingType?.label) {
                      <span class="badge badge--work" >{{ item.pricingType.label }}</span>
                    }
                  </div>
                }
                <!-- ─── REQUIRED (Jobs) ────────────────────────────── -->
                @case ('Required') {
                  @if (item.jobTitle) {
                    <p class="card__subtitle">{{ item.jobTitle }}</p>
                  }
                  <div class="card__meta-row">
                    <span class="meta-tag meta-tag--highlight">{{ item.jobCategory?.label }}</span>
                    <span class="meta-tag meta-tag--neutral">{{ item.jobType?.label }}</span>
                  </div>
                  @if (item.city?.nameHe) {
                    <div class="card__location">
                      <span class="location-pin">📍</span> {{ item.city.nameHe }}
                      @if (item.region?.label) {
                        <span> · {{ item.region.label }}</span>
                      }
                    </div>
                  }
                  <div class="card__badges">
                    @if (item.workLocationType?.label) {
                      <span class="badge badge--work"      >🏢 {{ item.workLocationType.label }}</span>
                    }
                    @if (item.isNegotiable) {
                      <span class="badge badge--negotiable">גמיש</span>
                    }
                  </div>
                }
                <!-- ─── PET ───────────────────────────────────────── -->
                @case ('Pet') {
                  <div class="card__meta-row">
                    <span class="meta-tag meta-tag--highlight">{{ item.petType?.label }}</span>
                    @if (item.breed?.label) {
                      <span class="meta-tag meta-tag--neutral">{{ item.breed.label }}</span>
                    }
                    @if (item.gender?.label) {
                      <span class="meta-tag meta-tag--neutral">{{ item.gender.label }}</span>
                    }
                  </div>
                  <div class="card__meta-row card__meta-row--secondary">
                    @if (item.age?.label) {
                      <span class="meta-tag meta-tag--neutral">{{ item.age.label }}</span>
                    }
                    @if (item.size?.label) {
                      <span class="meta-tag meta-tag--neutral">{{ item.size.label }}</span>
                    }
                  </div>
                  @if (item.city?.nameHe) {
                    <div class="card__location">
                      <span class="location-pin">📍</span> {{ item.city.nameHe }}
                    </div>
                  }
                  @if (item.suitability?.length) {
                    <div class="card__features">
                      @for (s of item.suitability | slice:0:3; track s) {
                        <span class="feature-tag">{{ s }}</span>
                      }
                    </div>
                  }
                }
              }
            </div><!-- /card__body -->
            <!-- ══ SCRUM-262/264: SELLER ROW — on EVERY card (business or private), so the
                 cards in a grid row keep the same layout and no card has an empty gap ══ -->
            @if (showSellerRow(item)) {
              <div class="card__dealer-row" [class.card__dealer-row--private]="!businessTag(item)">
                <a class="card__dealer" [class.card__dealer--private]="!businessTag(item)"
                   [routerLink]="['/seller/' + sellerId(item)]" (click)="saveState()"
                   [attr.aria-label]="'לעמוד המוכר ' + dealerName(item)">
                  <span class="card__dealer-avatar">
                    @if (dealerAvatar(item); as av) {
                      <img [src]="av" alt="" loading="lazy" />
                    } @else if (businessTag(item)) {
                      <span class="card__dealer-initials">{{ dealerInitials(item) }}</span>
                    } @else {
                      <i class="mdi mdi-account card__dealer-person"></i>
                    }
                  </span>
                  <span class="card__dealer-text">
                    <span class="card__dealer-name">
                      {{ dealerName(item) }}
                      @if (businessStore(item)?.verified) {
                        <i class="mdi mdi-check-circle card__dealer-verified" [title]="businessStore(item)?.verified_text"></i>
                      }
                    </span>
                    <span class="card__dealer-role">{{ businessTag(item) || 'מוכר פרטי' }}</span>
                  </span>
                </a>
                <!-- In-site message to the seller (relayed to the seller's WhatsApp) -->
                <button type="button" class="card__dealer-wa" (click)="messageSeller($event, item)"
                        [attr.aria-label]="'שליחת הודעה ל' + dealerName(item)" title="שליחת הודעה למוכר">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.214l-.252-.149-2.868.852.852-2.868-.168-.268A8 8 0 1112 20z"/>
                  </svg>
                  <span>הודעה</span>
                </button>
              </div>
            }
            <!-- ══ SHARED: FOOTER ════════════════════════════════════ -->
            <div class="card__footer">
              <div class="card__price-and-views">
                <div class="card__price-block">
                  <span class="price-label">{{ getPriceLabel(item) }}</span>
                  <span class="price" [class.price--green]="item.freeAdoption">
                    {{ getDisplayPrice(item) }}
                  </span>
                </div>
                <!-- SCRUM-119: ad impression count -->
                @if (item.impressions_count !== undefined && item.impressions_count !== null) {
                  <span class="card__views" [attr.aria-label]="item.impressions_count + ' צפיות'">
                    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6">
                      <path d="M1 10s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6z"/>
                      <circle cx="10" cy="10" r="2.4"/>
                    </svg>
                    {{ item.impressions_count }}
                  </span>
                }
              </div>
              <button
                class="card__save-btn"
                type="button"
                (click)="addToWishList($event, item)"
                [attr.aria-label]="'שמור ' + item.name"
                >
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M10 17.5S2 12 2 6.5A4.5 4.5 0 0 1 10 4.07 4.5 4.5 0 0 1 18 6.5C18 12 10 17.5 10 17.5z"/>
                </svg>
              </button>
            </div>
          </article>
        }
      </div>

      <!-- Infinite scroll: loading indicator -->
      @if (isLoadingMore) {
        <div class="load-more">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>
      }

      <!-- End of results -->
      @if (isLastPage && !isLoadingMore && productsList.length) {
        <div class="end-of-results">
          <span>✓ הצגת כל התוצאות</span>
        </div>
      }
    </div>

  </section>